<template>
  <div class="plan-detail">
    <BaseFrame
      :breadcrumb="[
        {
          name: 'plan',
          title: '采购计划列表'
        },
        {
          name: 'planDetail',
          title: '采购计划信息'
        }
      ]"
      :btns="[{
        text: '操作日志',
        name: 'log'
      }]"
      @btn-click="onBtnClick"
    >
      <div slot="info">
        <div class="info-container">
          <div class="info-item">
            <h4>采购计划单号：{{purchasePlan.code}}</h4>
            <div>商品类型：{{purchasePlan.goodsTypeName}}</div>
            <div>来源：{{purchasePlan.typeName}}</div>
            <div>采购人：{{purchasePlan.createUserName}}</div>
            <div>创建时间：{{purchasePlan.createTime}}</div>
          </div>
        </div>
      </div>
      <div slot="content">
        <ApprovalFlow :workNo="workNo" class="steps-wrap" :finishHide="true"/>
        <lk-card title="采购信息">
          <lk-form :label-width='134' label-position="right"
            :model='purchasePlan'>
            <lk-row>
              <lk-col span='7'>
                <lk-form-item label='采购类型:' prop='goodsType'>
                  <div>{{purchasePlan.goodsTypeName}}</div>
                </lk-form-item>
              </lk-col>
              <lk-col span='7' offset='1'>
                <lk-form-item label='来源:' prop='type'>
                  <div>{{purchasePlan.typeName}}</div>
                </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-row>
              <lk-col span='7'>
                <lk-form-item label='采购形式:' >
                  <div>{{purchasePlan.procurementFormName || ''}}</div>
                </lk-form-item>
              </lk-col>
            </lk-row>
          </lk-form>
        </lk-card>
        <lk-card title="商品信息" class="goods-card">
          <div class="sum-wrap">
            <div class="title-amount">总商品数量</div>
            <div class="content-amount">{{goodsNum}}</div>
            <div class="title-money">总金额（元）</div>
            <div class="content-money">&yen;{{purchaseAmount}}</div>
          </div>
          <lk-table border :columns='columns' :data='tableData'></lk-table>
        </lk-card>
        <lk-card title="有效期过期商品" class="expir-card" v-if="expirTable.length">
          <lk-table border :columns="expirColumns" :data="expirTable" class="plan-table"/>
        </lk-card>
      </div>
    </BaseFrame>
    <operate-log v-model="logShow" :logList="LogItems"/>
  </div>
</template>

<script>
import BaseFrame from '../../components/frame/NewBaseFrame.vue';
import purchase from '../../services/purchase';
import utils from '../../libs/utils';
import OperateLog from '../../components/operateLog';
import ApprovalFlow from '../../components/ApprovalFlow';
import Expire from '../../assets/expir.svg';

export default {
  name: 'planDetailApproval',
  components: {
    BaseFrame, OperateLog, ApprovalFlow,
  },
  data() {
    return {
      workNo: '',
      LogItems: [],
      logShow: false,
      queryParams: {
        purchasePlanId: '',
      },
      purchasePlan: {
        code: '',
        status: '',
        createUserName: '',
        createTime: '',
        goodsType: null,
      },
      columns: [
        {
          title: '行号',
          key: 'index',
          minWidth: 56,
          render: (h, params) => h('div', params.index + 1),
        },
        {
          title: '通用名称',
          minWidth: 142,
          tooltip: true,
          key: 'medicineInfoVoApprovedDrugNames',
          render: (h, params) => {
            const purchaseMedicineHasExpiryLicense = params.row.purchaseMedicineHasExpiryLicense;
            const resStr = params.row.medicineInfoVoApprovedDrugNames;
            let isExpir = false;
            let resDiv;
            const expirIcon = h('img', {
              class: 'expir-icon',
              attrs: {
                src: Expire,
              },
            });
            if (purchaseMedicineHasExpiryLicense == 1) {
              isExpir = true;
            }
            if (isExpir) {
              resDiv = [expirIcon, resStr];
            } else {
              resDiv = resStr;
            }
            return h('div', {
              class: {
                'approve-goods-wrap': true,
              },

            }, resDiv);
          },
        },
        {
          title: '规格',
          minWidth: 130,
          tooltip: true,
          key: 'medicineInfoVoSpecifications',
        },
        {
          title: '生产企业',
          minWidth: 142,
          tooltip: true,
          key: 'medicineInfoVoManufacturer',
        },
        {
          title: '上市许可持有人',
          minWidth: 142,
          tooltip: true,
          key: 'medicineInfoVoMah',
        },
        {
          title: '仓库库存',
          minWidth: 82,
          tooltip: true,
          key: 'inventoryNum',
        },
        {
          title: '上月销量',
          minWidth: 82,
          tooltip: true,
          key: 'lastMonthSaleNum',
        },
        {
          title: '在途数量',
          minWidth: 116,
          tooltip: true,
          key: 'onTheWayNum',
        },
        {
          title: '商品编码',
          minWidth: 82,
          tooltip: true,
          key: 'purchaseMedicineDrugSerialCode',
        },
        {
          title: '批准文号',
          tooltip: true,
          minWidth: 116,
          key: 'medicineInfoVoApprovalCode',
        },

        {
          title: '剂型',
          minWidth: 116,
          tooltip: true,
          key: 'medicineInfoVoDosageFormString',
        },
        {
          title: '单位',
          minWidth: 116,
          tooltip: true,
          key: 'purchaseMedicineDrugMinimumPackagingUnit',
        },
        {
          title: '产地',
          minWidth: 142,
          tooltip: true,
          key: 'purchaseMedicineCountryOfOrigin',
        },
        {
          title: '医保编码',
          minWidth: 142,
          tooltip: true,
          key: 'medicineInfoVoMedicalSerialCode',
        },
        {
          title: '计划数量',
          minWidth: 90,
          tooltip: true,
          fixed: 'right',
          key: 'purchaseMedicineNum',
        },
        {
          title: '计划单价',
          minWidth: 90,
          tooltip: true,
          fixed: 'right',
          key: 'purchaseMedicinePlanPrice',
        },
        {
          title: '供应商',
          fixed: 'right',
          tooltip: true,
          minWidth: 142,
          key: 'purchaseMedicineSupplierName',
        },
        {
          title: '款期',
          fixed: 'right',
          tooltip: true,
          minWidth: 142,
          key: 'purchaseMedicinePaymentPeriodName',
        },
        {
          title: '成本类型',
          fixed: 'right',
          tooltip: true,
          minWidth: 82,
          key: 'purchaseMedicinePaymentName',
        },
      ],
      tableData: [],
      page: 1,
      size: 10,
      count: 0,
      modalShow: false,
      expirColumns: [
        {
          title: '通用名称',
          minWidth: 116,
          key: 'medicineInfoVoApprovedDrugNames',
        },
        {
          title: '药品注册批件',
          minWidth: 116,
          key: 'purchaseMedicineDrugRegApprovalExpiry',
          render: (h, params) => {
            const purchaseMedicineDrugRegApprovalExpiry = params.row.purchaseMedicineDrugRegApprovalExpiry;
            let resStr = '-';
            let isExpir = false;
            if (purchaseMedicineDrugRegApprovalExpiry) {
              resStr = utils.formatTime(purchaseMedicineDrugRegApprovalExpiry, 'YYYY/MM/DD');
            }
            if (params.row.purchaseMedicineIsDrugRegApprovalExpiry == 1) {
              isExpir = true;
            }
            return h('span', {
              class: {
                'orange-words': isExpir,
              },
            }, resStr);
          },
        },
        {
          title: '进口注册证',
          minWidth: 116,
          key: 'purchaseMedicineImportRegCertExpiry',
          render: (h, params) => {
            const purchaseMedicineImportRegCertExpiry = params.row.purchaseMedicineImportRegCertExpiry;
            let resStr = '-';
            let isExpir = false;
            if (purchaseMedicineImportRegCertExpiry) {
              resStr = utils.formatTime(purchaseMedicineImportRegCertExpiry, 'YYYY/MM/DD');
            }
            if (params.row.purchaseMedicineIsImportRegCertExpiry == 1) {
              isExpir = true;
            }
            return h('span', {
              class: {
                'orange-words': isExpir,
              },
            }, resStr);
          },
        },
        {
          title: '生产许可证',
          minWidth: 116,
          key: 'purchaseMedicineProdLicenseExpiry',
          render: (h, params) => {
            const purchaseMedicineProdLicenseExpiry = params.row.purchaseMedicineProdLicenseExpiry;
            let resStr = '-';
            let isExpir = false;
            if (purchaseMedicineProdLicenseExpiry) {
              resStr = utils.formatTime(purchaseMedicineProdLicenseExpiry, 'YYYY/MM/DD');
            }
            if (params.row.purchaseMedicineIsProdLicenseExpiry == 1) {
              isExpir = true;
            }
            return h('span', {
              class: {
                'orange-words': isExpir,
              },
            }, resStr);
          },
        },
        {
          title: '备注',
          minWidth: 116,
          key: 'purchaseMedicineExpiryRemark',
        },
      ],
    };
  },
  methods: {
    onLogCancel() {
      this.logShow = false;
    },
    onShowLog() {
      this.logShow = true;
    },
    onBtnClick(name) {
      if (name === 'log') {
        this.onShowLog();
      }
    },
    getLog() {
      const params = {
        purchasePlanId: this.$route.params.purchasePlanId,
      };
      this.$store.commit('setDisableLoading', true);
      purchase.planLog(params).then((res) => {
        if (res.data.status === 200) {
          let logItem = {};
          res.data.data.forEach((item) => {
            const time = utils.formatTime(item.createTime, 'YYYY/MM/DD HH:mm');
            if (item.type == 1) {
              logItem = {
                content: `${time}由${item.createUserName}创建`,
              };
            }
            if (item.type == 2) {
              let children = [];
              if (item.operateList.length) {
                children = item.operateList.map(modifyItem => ({
                  content: `${modifyItem.content},旧值: ${modifyItem.oldValue}, 新值: ${modifyItem.newValue}`,
                }));
              }
              logItem = {
                content: `${time}由${item.createUserName}修改`,
                children,
              };
            }
            if (item.type == 3) {
              let children = [];
              let status = '';

              if (item.operateList.length) {
                children = item.operateList.map((reviewItem) => {
                  const reviewTime = utils.formatTime(reviewItem.operateTime, 'YYYY/MM/DD HH:mm');
                  if (reviewItem.workStatus === 1) {
                    status = '通过';
                  } else if (reviewItem.workStatus === 2) {
                    status = '驳回';
                  }
                  return {
                    content: `${reviewTime},由${reviewItem.operateUserName}审批, 结果： ${status}，意见： ${reviewItem.idea || '无'}`,
                  };
                });
              }
              logItem = {
                content: `${time}由${item.createUserName}审批`,
                children,
              };
            }
            this.LogItems.push(logItem);
          });
        }
      });
    },
    getData() {
      this.queryParams.purchasePlanId = this.$route.params.purchasePlanId;
      purchase.planInfo(this.queryParams).then((res) => {
        if (res.data.status === 200) {
          this.data = [];
          this.purchasePlan.createTime = utils.formatTime(res.data.data.purchasePlan.createTime, 'YYYY/MM/DD HH:mm');
          this.purchasePlan.createUserName = res.data.data.purchasePlan.createUserName;
          this.purchasePlan.code = res.data.data.purchasePlan.code;
          this.purchasePlan.typeName = res.data.data.purchasePlan.typeName;
          this.purchasePlan.goodsTypeName = res.data.data.purchasePlan.goodsTypeName;
          this.purchasePlan.goodsType = res.data.data.purchasePlan.goodsType;
          this.purchasePlan.procurementFormName = res.data.data.purchasePlan.procurementFormName;
          res.data.data.purchaseMedicineInfoVoList.forEach((item) => {
            const result = {};
            utils.exchangeTable(item, result);
            this.tableData.push(result);
          });
          if (res.data.data.purchasePlan && res.data.data.purchasePlan.workNo) {
            this.workNo = res.data.data.purchasePlan.workNo;
          }
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
  },
  watch: {
    'purchasePlan.goodsType': function goodsTypeHandler() {
      if (this.purchasePlan.goodsType === 2) {
        this.columns.splice(9, 1, {
          title: '注册证号/备案号',
          minWidth: 124,
          tooltip: true,
          key: 'medicineInfoVoApprovalCode',
        });
      } else {
        this.columns.splice(9, 1, {
          title: '批准文号',
          minWidth: 116,
          tooltip: true,
          key: 'medicineInfoVoApprovalCode',
        });
      }
    },
  },
  created() {
    this.getData();
    this.getLog();
  },
  computed: {
    expirTable() {
      return this.tableData.filter(value => value.purchaseMedicineHasExpiryLicense == 1);
    },
    goodsNum() {
      let res = 0;
      this.tableData.forEach((item) => {
        res += item.purchaseMedicineNum;
      });
      return res.toFixed(2);
    },
    purchaseAmount() {
      let res = 0;
      this.tableData.forEach((item) => {
        res += (item.purchaseMedicineNum * item.purchaseMedicinePlanPrice);
      });
      return res.toFixed(2);
    },
  },
};
</script>
<style lang="less">
.plan-detail{
  .plan-table-index{
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .plan-table{
    margin-top: 10px;
  }
  .steps-wrap{
    // padding-left: 30%;
    padding-top: 30px;
    padding-bottom: 30px;
  }
  .orange-words{
    color: #FF4D07;
  }
  .approve-goods-wrap{
    display: flex;
    img{
      margin-right:4px;
    }
  }
  .expir-card{
    margin-top: 12px;
  }
  .goods-card{
    margin-top:12px;
    .ivu-card-body{
      position: relative;
    }
  }
  .info-item{
    &:before{
      content: "";
      display: inline-block;
      border: 1px solid #1890FF;
      margin-right: 6px;
      height: 12px;
      position: relative;
      top:2px;
    }
    h4{
      display: inline;
    }
    div{
      padding-left:8px;
    }
  }
}
</style>
